/**
 * @generated SignedSource<<652ea7af242e03bfaf2732c7a499d0d6>>
 * @relayHash cfc990ad5a494b6624e86684c7b43e0a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 656de23d90aa2410db1829f8216ec0ff174367722f5bec0cb54067cec7559a19

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SchedulesPageQuery } from './SchedulesPageQuery.graphql';

const node: PreloadableConcreteRequest<SchedulesPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "656de23d90aa2410db1829f8216ec0ff174367722f5bec0cb54067cec7559a19",
    "metadata": {},
    "name": "SchedulesPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
